export default __webpack_public_path__ + "static/media/0102.f71bfe78.png";